export default __webpack_public_path__ + "static/media/500.86713904.png";